/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_AudioInputs */

const en_uploading_audio = /** @type {(inputs: Uploading_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading audio...`)
};

const fr_uploading_audio = /** @type {(inputs: Uploading_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement audio en cours...`)
};

const de_uploading_audio = /** @type {(inputs: Uploading_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio wird hochgeladen...`)
};

const it_uploading_audio = /** @type {(inputs: Uploading_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento dell'audio...`)
};

const ru_uploading_audio = /** @type {(inputs: Uploading_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка аудио...`)
};

const es_uploading_audio = /** @type {(inputs: Uploading_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subiendo audio...`)
};

const zh_cn2_uploading_audio = /** @type {(inputs: Uploading_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在上传音频……`)
};

const ja_uploading_audio = /** @type {(inputs: Uploading_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声ファイルをアップロード中...`)
};

const hi_uploading_audio = /** @type {(inputs: Uploading_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो अपलोड हो रहा है...`)
};

const pt_pt2_uploading_audio = /** @type {(inputs: Uploading_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando áudio...`)
};

/**
* | output |
* | --- |
* | "Uploading audio..." |
*
* @param {Uploading_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_audio = /** @type {((inputs?: Uploading_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_uploading_audio(inputs)
	if (locale === "de") return de_uploading_audio(inputs)
	if (locale === "it") return it_uploading_audio(inputs)
	if (locale === "ru") return ru_uploading_audio(inputs)
	if (locale === "es") return es_uploading_audio(inputs)
	if (locale === "zh-CN") return zh_cn2_uploading_audio(inputs)
	if (locale === "ja") return ja_uploading_audio(inputs)
	if (locale === "hi") return hi_uploading_audio(inputs)
	if (locale === "pt-PT") return pt_pt2_uploading_audio(inputs)
	return en_uploading_audio(inputs)
});